import React from 'react';

/**
 * Two flavours:
 *  - variant="empty": no public models exist at all
 *  - variant="no-results": filters/search matched nothing
 */
const HubEmptyState = ({ variant = 'empty', onClear }) => {
  const isNoResults = variant === 'no-results';
  return (
    <div className="hub-empty">
      <div className="hub-empty__icon">
        <i className={`fa ${isNoResults ? 'fa-search' : 'fa-cubes'}`} aria-hidden />
      </div>
      <h3 className="hub-empty__title">
        {isNoResults ? 'No models match your filters' : 'No public models yet'}
      </h3>
      <p className="hub-empty__text">
        {isNoResults
          ? 'Try a different search term or clear the active filters.'
          : 'Create a model and set it to “Public” to share it in the hub.'}
      </p>
      {isNoResults && onClear && (
        <button type="button" className="hub-empty__action" onClick={onClear}>
          <i className="fa fa-undo" aria-hidden /> Clear filters
        </button>
      )}
    </div>
  );
};

export default HubEmptyState;
